import { Dispatch } from "redux";
import client from "../../client";
import { IDType } from "../../config/types";
import { defaultGet } from "./all";
import { LeagueActions, LeagueActionTypes } from "./types";
import { League, LeagueService, SportEnum } from "../../client/api";

export function fetchLeagues(
  dispatch: Dispatch<LeagueActions>,
  regionId: IDType,
  sports: SportEnum
) {
  defaultGet(
    dispatch,
    LeagueActionTypes.FETCH_SUCCESS,
    LeagueActionTypes.FETCH_ERROR,
    LeagueActionTypes.FETCH_LEAGUES,
    client().getLeaguesOfAoi,
    false,
    { id: regionId },
    regionId,
    sports
  );
}

export function fetchCategories(dispatch: Dispatch<LeagueActions>) {
  defaultGet(
    dispatch,
    LeagueActionTypes.FETCH_CATEGORIES_SUCCESS,
    LeagueActionTypes.FETCH_ERROR,
    LeagueActionTypes.FETCH_LEAGUES,
    client().getLeagueCategories,
    false,
    false
  );
}

export function fetchLeagueById(
  dispatch: Dispatch<LeagueActions>,
  leagueId: IDType
) {
  dispatch({ type: LeagueActionTypes.FETCH_LEAGUES });
  LeagueService.getLeagueByIdLeagueLeagueIdGet(leagueId)
    .then((response: League) => {
      dispatch({
        type: LeagueActionTypes.FETCH_SUCCESS_SINGLE,
        payload: [response]
      });
    })
    .catch(() => {
      // reuse league fetch error channel
      dispatch({
        type: LeagueActionTypes.FETCH_ERROR,
        payload: "serverError" as any
      });
    });
}

